import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useEffect } from "react";

const useProductInfosCallback = (productInfos: ProductInfo[], callback: () => any, canCallback = true) => {
    const canSeePrices = useSettingsCollection().productSettings.canSeePrices;
    const previousProductInfos = usePrevious(productInfos);

    const allowCallback =
        canCallback &&
        Boolean(productInfos?.length) &&
        (canSeePrices
            ? productInfos.every(x => x.pricing && x.inventory)
            : previousProductInfos?.[0]?.productId !== productInfos?.[0]?.productId);

    useEffect(() => {
        if (allowCallback) {
            callback();
        }
    }, [allowCallback]);
};

export default useProductInfosCallback;
